import {Tag} from './tag.model';
import {ClientPlacement} from './clientPlacement.model';
import {ClientContact} from './clientContact.model';

export class Client {
    id: string;
    identifier: string;
    name: string;
    dob: string;
    firstName: string;
    lastName: string;
    gender: string;
    educationYears: number;
    placements: Array<ClientPlacement> = [];
    tags: Array<Tag> = [];
    contact: ClientContact;
    active: boolean;
    relationshipToClient: string;

    constructor(client: any) {
        if (client) {
            this.id = client.id;
            this.identifier = client.identifier;
            this.name = client.name;
            this.dob = client.dob;
            this.firstName = client.firstName;
            this.lastName = client.lastName;
            this.gender = client.gender;
            this.educationYears = client.educationYears;
            if (client.placements) {
                client.placements.forEach(placement => {
                    this.placements.push(new ClientPlacement(placement));
                });
            }
            if (client.tags) {
                client.tags.forEach(tag => {
                    this.tags.push(new Tag(tag));
                });
            }
            this.contact = new ClientContact(client.contact);
            this.active = client.active;
            this.relationshipToClient = client.relationshipToClient;
        }
    }
}
